"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _fecha = _interopRequireDefault(require("fecha"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = {
  firstOfWeek: function firstOfWeek() {
    return 0;
  },
  parse: function parse(value, format) {
    return _fecha["default"].parse(value, format);
  },
  format: function format(date, _format) {
    return _fecha["default"].format(date, _format);
  },
  formats: {
    "default": 'ddd MMM DD YYYY HH:mm:ss',
    date: 'dddd, MMMM D, YYYY',
    time: 'HH:mm:ss',
    header: 'MMMM YYYY',
    footer: 'dddd, MMMM D, YYYY',
    weekday: 'dd',
    dayOfMonth: 'D',
    month: 'MMM',
    year: 'YYYY',
    decade: '',
    century: ''
  }
};
exports["default"] = _default;